import classNames from "classnames";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import { type ComponentProps } from "react";
import styles from "./SProviderLink.module.css";

export default function SProviderLink({ className, ...props }: ComponentProps<typeof FilmwebLink>) {
  return <FilmwebLink className={classNames(styles.SProviderLink, className)} {...props} />;
}
